var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBox',{attrs:{"bg":['none', '#F6F6F9'],"minHeight":"100vh","width":"100vw","position":"sticky"}},[_c('Header',{attrs:{"titleLabel":"Seguro Viagem"}}),_c('omint-slider',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }